import Flex from "../../../components/common/Flex";
import LoginForm from "../../../components/auth/LoginForm";

const Login = () => {
	return (
		<>
			<Flex justifyContent="between" alignItems="center" className="mb-2">
				<h5>Log in</h5>
			</Flex>
			<LoginForm />
		</>
	);
};

export default Login;
